module.exports = __webpack_public_path__ + "img/2.toy.5be41e23.jpg";